import { pinnedMessageFocusSlice } from '../store/slices/pinnedMessageFocusSlice';

export const { setPinnedMessageInFocus: pinnedMessageInFocus } = pinnedMessageFocusSlice.actions;
